import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import moment from 'moment';

import compose from 'recompose/compose';
import lifecycle from 'recompose/lifecycle';
import selectIsToday from 'app/selectors/isToday';

import config from 'app/config';
import * as passagesActions from 'app/actions/passages/short';
import * as cafeteriaActions from 'app/actions/cafeteria/costs';
import { getIsStudent } from 'app/selectors/user';


const mapStateToProps = (state, props) => {
  const { user } = state;
  const { params: { date } } = props;
  const isStudent = getIsStudent(state);
  return {
    isStudent,
    // projectName: state.dealer.project_name,
    students: isStudent ? { ...state.students, keys: [user.student.id] } : state.students,
    isToday: selectIsToday(state, { date }),
  };
};

const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators({
    ...passagesActions,
    ...cafeteriaActions,
  }, dispatch),
});

export default compose(
  connect(mapStateToProps, mapDispatchToProps),
  lifecycle({

    componentDidMount() {
      const { actions, router, params: { date }, location: { pathname }, isToday } = this.props;
      const isDateValid = moment(date, config.dateFormat, true).isValid();
      if (!isDateValid || !isToday) {
        const baseUrl = pathname.split('/').slice(0, 2).join('/');
        router.replace(`${baseUrl}/${moment().format(config.dateFormat)}`);
      } else {
        // actions.fetchDnevnikData(date);
        actions.fetchPassagesShot(date);
        actions.fetchCosts(date);
      }
    },

    // $FlowFixMe
    UNSAFE_componentWillReceiveProps(nextProps) {
      // Так как данные идут за неделю, запрос на сервер, если дата не входит в  эту неделю
      const { actions, params: { date } } = this.props;
      const { params: { date: newDate } } = nextProps;
      const isValid = moment(newDate, config.dateFormat, true).isValid();
      if (date !== newDate && isValid) {
        // Дневник запрашиваем, только если другая неделя (данные в дневнике на неделю)
        // if (!moment(date).isSame(newDate, 'week')) {
        //   actions.fetchDnevnikData(newDate); // ..
        // }
        actions.fetchPassagesShot(newDate);
        actions.fetchCosts(newDate);
      }
    },
  })
);
